import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from './AppContainer';
import { initSentry } from './services/sentry';
import { registerServiceWorker } from './services/serviceWorker';
import config from './config/config';
import { ConfigNamesEnum } from './store/storeTypes';

// Initialize Sentry for all environments
initSentry();

ReactDOM.render(<AppContainer />, document.getElementById('root'));

registerServiceWorker();
